import ImageComponent from "../ImageComponent"

interface SingleImageCardProps{
    imageUrl:string,
    imageName:string
}

const SingleImageCard = ({imageUrl,imageName}:SingleImageCardProps) => {
  return (
    <>
        <div className="overflow-hidden rounded-[10px] md:rounded-3xl">
            <ImageComponent url={imageUrl} img_title={imageName} object_cover={true}/>
        </div>
    </>
  )
}

export default SingleImageCard